import { Component } from '@angular/core';

@Component({
  selector: 'app-assets-importer',
  templateUrl: './assets-importer.component.html',
  styleUrls: ['./assets-importer.component.scss']
})
export class AssetsImporterComponent {

}
